import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
	ContainerProps,
  Paper,
  Stack,
	useMediaQuery
} from '@mui/material'

import { ConfigureTabs, ConfigureTabIdentifier } from './components/tabs'

import { ConfigureUserPage } from './user'
import { ConfigureGroupPage } from './group'
import { ConfigureManufacturerPage } from './manufacturer'
import { ConfigureNotificationPage } from './notification'
import { ConfigureAgreementPage } from './agreement'
import { setDocumentTitle } from 'shared/util'

import { useTenant } from 'features/tenant/context'
import { useTopBar } from 'components/topBar/container'
import { useSideMenu } from 'components/sideMenu/container'
import { ConfigureTenantPage } from './tenant';
import { AuditLogSearchPage } from './auditLog';

type ConfigurePageProps = {
  topBarState: ReturnType<typeof useTopBar>
  sideMenuState: ReturnType<typeof useSideMenu>
} & ContainerProps
export const ConfigurePage = ({
	topBarState: { setBreadCrumbs },
	sideMenuState: { setActivePage },
	...others
}: ConfigurePageProps) => {
	const tenant = useTenant()
  const isVertical: boolean = useMediaQuery("(min-width: 1400px)")
	const [params, setParams] = useSearchParams()
	const [page, setPage] = useState<ConfigureTabIdentifier>(
		() => {
			const page = params.get('page')
			if (page === 'user') return 'user'
			if (page === 'group') return 'group'
			if (page === 'tenant') return 'tenant'
			if (page === 'manufacturer') return 'manufacturer'
			if (page === 'notification') return 'notification'
			if (page === 'agreement') return 'agreement'
			if (page === 'auditLog') return 'auditLog'
			return 'user'
		}
	)
	useEffect(
		() => {
			setParams((prev) => {
				prev.set('page', page)
				return prev
			})
		},
		[page, setParams]
	)
  useEffect(
		() => {
			const pageName = (
				page === 'user' ? 'ユーザー管理' :
				page === 'group' ? 'グループ管理' :
				page === 'tenant' ? 'テナント管理' : 
				page === 'manufacturer' ? '製薬企業管理' :
				page === 'notification' ? 'お知らせ管理' : 
				page === 'agreement' ? '利用規約管理' : 
				page === 'auditLog' ? '監査ログ検索' : undefined
			)
			if (pageName) {
				setBreadCrumbs([{ label: pageName }])
				setDocumentTitle(pageName, tenant.tenantName)
			}
			setActivePage('configure')
		},
		[tenant, page, setBreadCrumbs, setActivePage]
	)
	return (
		<Container
			{...others}

			maxWidth="xl"
			sx={{
				height: '100%',
				maxHeight: '100%',
				overflow: 'hidden',
				padding: 2,
				position: 'relative'
			}}
		>
			<Paper sx={{ height: '100%', overflow: 'hidden' }}>
				<Stack direction="row" height="100%" maxHeight="100%" maxWidth="100%">
					{ isVertical && (
						<Box
							flexShrink={0}
							paddingY={2}
							sx={{
								borderRight: 1,
								borderColor: 'divider'
							}}
						>
							<ConfigureTabs active={page} onChangeActive={setPage} orientation='vertical'/>
						</Box>
					) }
					<Stack flexGrow={1} direction="column" maxHeight="100%" maxWidth="100%" overflow="hidden">
						{ !isVertical && (
							<Box
								paddingX={2}
								sx={{
									borderBottom: 1,
									borderColor: 'divider'
								}}
							>
								<ConfigureTabs active={page} onChangeActive={setPage} orientation='horizontal'/>
							</Box>
						) }

						{page === 'user' ? (
							<ConfigureUserPage/>
						) : page === 'group' ? (
							<ConfigureGroupPage/>
						) : page === 'tenant' ? (
							<ConfigureTenantPage/>
						) : page === 'manufacturer' ? (
							<ConfigureManufacturerPage/>
						) : page === 'notification' ? (
							<ConfigureNotificationPage/>
						) : page === 'agreement' ? (
							<ConfigureAgreementPage/>
						) : page === 'auditLog' ? (
							<AuditLogSearchPage/>
						) : <></>}
					</Stack>
				</Stack>
			</Paper>
		</Container>
	)
}